import type { APIListing, APIPortal } from "models/types/api-listing";
import { apiClient } from "utils/api-client/index";
import { createModel } from "utils/models";

const include = [
  "address",
  "documents",
  "agency_contacts",
  "property{details}",
  "marketing{adverts,image,images,floorplans,links,campaign.entries}",
  "applicant_feedback{entries{agent,attendees,group}}",
  "agent_updates{entries{agent}}",
  "offers{applicants,agent}",
  `summary{${[
    "days_since_listed",
    "count_of_enquiries_by_source",
    "count_of_interested_groups_by_interest_level",
    "count_of_inspections_and_open_homes",
    "count_of_unique_people_who_have_enquired",
    "count_of_unique_people_who_have_inspected",
    "count_of_unique_people_who_have_inspected_more_than_once",
    "count_of_people_who_have_inspected_including_duplicates",
    "list_of_price_indications",
    "list_of_offer_amounts",
    "most_common_enquiry_source",
  ].join(",")}}`,
  "performance{stats}",
  "events{agent,feedback{feedback,agent}}",
  "portal{account{branding,preferences}}",
].join(",");

export const listingsModel = createModel("listings", {
  queries: {
    read: (listingId?: string) => ({
      throwOnError: true,
      meta: {
        showErrorModal: false,
      },
      queryKey: ["read", listingId],
      queryFn: () =>
        apiClient.get<APIListing>(`/portal/listings/${listingId}`, {
          include,
        }),

      keepPreviousData: true,
    }),

    readRegion: (listingId?: string) => ({
      throwOnError: true,
      meta: {
        showErrorModal: false,
      },
      queryKey: ["read", "region", listingId],
      queryFn: async (): Promise<APIPortal["region"] | null> => {
        if (!listingId) {
          // Skip query if no listingId is provided
          return new Promise((res) => setTimeout(() => res(null), 0));
        }

        const resp = await apiClient.get<APIListing>(
          `/portal/listings/${listingId}`,
          { include },
        );

        return resp.portal?.region ?? null;
      },

      keepPreviousData: true,
    }),
  },
});
